(function ($, DataTable) {

if ( ! DataTable.ext.editorFields ) {
    DataTable.ext.editorFields = {};
}

const Editor = DataTable.Editor;
const _fieldTypes = DataTable.ext.editorFields;

_fieldTypes.combobox = {
    create: function ( conf ) {
        var that = this;

        conf._enabled = true;

        // Create the elements to use for the input
        conf._input = $(
            '<div id="' + Editor.safeId( conf.id ) + '">'
                + '<input type="text" class="combobox" list="datalist-' + conf.datalist + '" value="" />'
			+ '</div>');

        return conf._input;
    },

    get: function ( conf ) {
        return $( 'input.combobox', conf._input ).attr('value');
    },

    set: function ( conf, val ) {
		return $(  'input.combobox', conf._input ).attr('value', val );
    },

	canReturnSubmit: function() {
		return true;
	},

    enable: function ( conf ) {
        conf._enabled = true;
        $(conf._input).prop( 'disabled', false );
    },

    disable: function ( conf ) {
        conf._enabled = false;
        $(conf._input).prop( 'disabled', true );
    }
};

})(jQuery, jQuery.fn.dataTable);
